import BaseAppService from "../../../application/platform/base-app-service";
import PortalAppService from "../../../application/platform/portal-app-service";
import { IPortalHomeResponse } from "../../../model/base/response/portal-home-response";
import { ACTION_TYPES, useGlobalDispatch } from "./global-context";

// Falha ao buscar a customização não derruba o portal: segue com a home padrão
const getPortalHome = async (): Promise<IPortalHomeResponse> => {
    try {
        return await PortalAppService.getHome();
    } catch (error) {
        console.error('Error loading portal home:', error);
        return { isCustomized: false, sections: [] };
    }
};

export const useHGlobalController = () => {
    const globalDispatch = useGlobalDispatch();
    async function getData() {
        try {
            const applicationData = await BaseAppService.requestApplicationData();
            globalDispatch({
                type: ACTION_TYPES.setApplicationData,
                payload: applicationData,
            });

            const menus = await BaseAppService.requestMenus();
            globalDispatch({
                type: ACTION_TYPES.setMenus,
                payload: menus,
            });

            const parametersPortal = await PortalAppService.getParameters();
            globalDispatch({
                type: ACTION_TYPES.setParametersPortal,
                payload: parametersPortal,
            });

            globalDispatch({
                type: ACTION_TYPES.setPortalHome,
                payload: await getPortalHome(),
            });
        } catch (error: any) {
            console.error('Error loading application data:', error);

            // Extract status code and message from error
            const statusCode = error?.response?.status || error?.statusCode;
            const message = error?.response?.data?.message || error?.message || 'Erro desconhecido';

            globalDispatch({
                type: ACTION_TYPES.setError,
                payload: {
                    statusCode,
                    message,
                },
            });
        }
    }

    return {
        getData
    };
}